import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import Modal from "components/Modal/Modal"
import Checkbox from "components/Checkbox/Checkbox"
import { FormButtons } from "components-design-system"
import "./DeleteArmModal.scss"

// hooks
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const DeleteArmModal = (props) => {
  const { type } = props
  const [deleteAll, setDeleteAll] = useState(false)
  let { showModal, setShowModal, handleDelete, view, arm, disableDeleteAll } = props

  const { formView } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
    }))
  )

  const onSubmit = () => {
    if (formView.id === "global") handleDelete(arm, true)
    else handleDelete(arm, deleteAll)
    setDeleteAll(false)
    setShowModal(false)
  }

  let title = "arm"
  if (type === "arm") title = "arm"
  else if (type === "intervention") title = "intervention"
  else title = "subject analysis set"

  return (
    <Modal
      title={`Delete ${title}`}
      open={showModal}
      okText="Delete"
      onOk={onSubmit}
      okButtonProps={{
        danger: true,
      }}
      onCancel={() => setShowModal(false)}
      type="delete-alt"
      className="delete-arm-modal"
    >
      {formView.id === "global" ? (
        <div className="delete-arm-modal-content">
          <div className="del-arm-modal-message">
            NOTE: Deleting from Global view will delete items from all registries.
          </div>
        </div>
      ) : (
        <div className="delete-arm-modal-content">
          <div className="del-arm-modal-message">
            <Checkbox
              label="Delete from all registries"
              disabled={disableDeleteAll}
              onChange={(e) => setDeleteAll(e.target.checked)}
              checked={deleteAll}
            />
            <Checkbox
              label="Delete from registry"
              disabled={true}
              checked={true}
            />
          </div>
        </div>
      )}
    </Modal>
  )
}

export default DeleteArmModal
